import { render, staticRenderFns } from "./MetadataMapping.vue?vue&type=template&id=4c255ad8&"
import script from "./MetadataMapping.vue?vue&type=script&lang=js&"
export * from "./MetadataMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports